import { lazy } from "react";
const ListAllRooms = lazy(() => import("./pages/list-all-rooms"));
const CreateEditRoom = lazy(() => import("./pages/activity-room-configurations/create-activity"));
const ActivityRoomConfigurations = lazy(() => import("./pages/activity-room-configurations"));

export const basePath = "/app/dashboard/live-streams/"

export const StreamRoomsPaths = {
    list:basePath + "stream-rooms",
    create:basePath + "create-room",
    activityRoomConfigurations:basePath + ":activityId",
}

export const StreamRoomsBreadcrumbs = {
    list: {
        href: StreamRoomsPaths.list,
        label: "Stream Rooms"
    },
    create: {
        href: StreamRoomsPaths.create,
        label: "Create Room"
    },
    activityRoomConfigurations:{
        href: null,
        label: "Activity Room Configurations"
    }
}

const StreamRoomsRoutes = [
    {
        path: StreamRoomsPaths.list,
        component: ListAllRooms
    },
    {
        path: StreamRoomsPaths.create,
        component: CreateEditRoom
    },
    {
        path: StreamRoomsPaths.activityRoomConfigurations,
        component: ActivityRoomConfigurations
    }
]

export default StreamRoomsRoutes